// extracted by mini-css-extract-plugin
export default {"resizer__horizontal":"Resizer2_resizer__horizontal__3lcH-"};